import {DiscountTypeVariant} from '../BenefitFiltersDrawer';

export const MIN_PERCENTAGE_DISCOUNT_VALUE = 0;
export const MAX_PERCENTAGE_DISCOUNT_VALUE = 100;

export type DiscountTypeConfig = {
  label: string;
  value: DiscountTypeVariant;
  minValue?: number;
  maxValue?: number;
  unit: string;
  inputProps?: {
    sx?: Record<string, any>;
  };
};

export const discountTypes: Record<DiscountTypeVariant, DiscountTypeConfig> = {
  [DiscountTypeVariant.percentage]: {
    label: 'Percentage',
    value: DiscountTypeVariant.percentage,
    minValue: MIN_PERCENTAGE_DISCOUNT_VALUE,
    maxValue: MAX_PERCENTAGE_DISCOUNT_VALUE,
    unit: '%',
    inputProps: {
      sx: {
        width: '80px'
      }
    }
  },
  [DiscountTypeVariant.amount]: {
    label: 'Fixed Amount',
    value: DiscountTypeVariant.amount,
    unit: 'kr',
    inputProps: {
      sx: {
        width: '146px'
      }
    }
  },
  [DiscountTypeVariant.none]: {
    label: 'Not Selected',
    value: DiscountTypeVariant.none,
    unit: ''
  }
};
